export default __webpack_public_path__ + "ca2541b118903e4af45ad351b7daf662.svg";